import { useCallback, useMemo, useState } from "react";
import shallow from "zustand/shallow";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Select,
    MenuItem,
    FormControl,
    InputLabel,
} from "@mui/material";
import useSectionsBySide from "./hooks/useSectionsBySide";
import { useShelvingStore, useStoreRoom } from "../../../../store";
import styles from "./SpecificationPanel.module.scss";
import Blueprint from "../../../icons/Blueprint";
import { generateBlueprintPdf } from "../../../PDFBlueprintGenerator";

export function GenerateBluePrintPdf() {
    const [opened, setOpened] = useState(false);
    const [variant, setVariant] = useState("compact");

    const { roomLength, roomDepth, roomHeight } = useStoreRoom(
        (state) => ({
            roomLength: state.length,
            roomDepth: state.depth,
            roomHeight: state.height,
        }),
        shallow
    );

    const { shelvings } = useShelvingStore(
        (state) => ({
            shelvings: state.shelving,
        }),
        shallow
    );

    const sectionsList = useSectionsBySide();
    const sectionsData = useMemo(
        () =>
            sectionsList.map((section) => ({
                ...section,
                offsetCeiling: shelvings[section.side].offsetCeiling,
                offset: section.offset + shelvings[section.side].sideIndent,
            })),
        [sectionsList, shelvings]
    );

    const generateBluePrint = useCallback(async () => {
        setOpened(false);
        return generateBlueprintPdf(roomLength, roomDepth, roomHeight, sectionsData, {
            eachViewOnSeparatePage: variant === "page",
        });
    }, [roomLength, variant, roomDepth, roomHeight, sectionsData]);

    return (
        <>
            <div onClick={() => setOpened(true)} className={styles.pdf}>
                <Blueprint />
            </div>
            <Dialog fullWidth onClose={() => setOpened(false)} open={opened}>
                <DialogTitle>Выберите вариант компоновки видов на листе</DialogTitle>
                <DialogContent>
                    <FormControl sx={{ mt: 1 }} fullWidth>
                        <InputLabel>Вариант</InputLabel>
                        <Select value={variant} onChange={(e) => setVariant(e.target.value)} label="Вариант">
                            <MenuItem value="compact">Компактный</MenuItem>
                            <MenuItem value="page">Постраничный</MenuItem>
                        </Select>
                    </FormControl>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setOpened(false)}>Отмена</Button>
                    <Button onClick={generateBluePrint} autoFocus>
                        Получить PDF
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
}
